import classnames from "classnames";
import pluralize from "pluralize";
import React from "react";

import dayjs from "../../shared/helpers/dayjs";

import { OFFER_DATE_FORMAT } from "../../const/DateFormatConsts";

import CustomerDetailsForm from "./CustomerDetailsForm";
import Loading from "../shared/Loading";
import OfferConfirmation from "./LegacyOfferConfirmation";
import OfferError from "./OfferError";
import OfferHeader from "./OfferHeader";
import OfferSummary from "./OfferSummary";
import SelectOffer from "./SelectOffer";
import TeeTimesForm from "./TeeTimesForm";

class Offer extends React.Component {
  constructor() {
    super();

    this.state = {
      offerSelected: false,
      panelNumber: 0,
      isStripeLoading: false,
      isBookingInProgress: false,
      hasSucceeded: false,
      hasFailed: false,
      reference: "",
      errorMessage: "",
      selectedPax: 2,
      selectedTeeTimes: {}
    };
  }

  _togglePageLoading = () => {
    document
      .getElementById("js-page-loading")
      .classList
      .toggle("is-visible", this.state.isBookingInProgress);
  };

  _makePrebooking = (pax, teeTimeIds, customerParams) => {
    const id = this.props.offer.id;
    const url = `${window.location.pathname}/${id}/prebook`;
    const data = {
      customer_params: customerParams,
      deal: {
        id,
        pax,
        tee_time_ids: teeTimeIds
      }
    };

    const defaultMessage = `
            Sorry, something went wrong... please try booking again, or contact
            us on 0800 043 6644 if you're still experiencing problems.
            `;

    const success = response => {
      const stripe = Stripe(window.stripeKey);
      stripe.redirectToCheckout({
        sessionId: response.stripe_checkout_session_id
      }).then(() => {
        this.setState({
          hasFailed: true,
          hasSucceeded: false,
          errorMessage: defaultMessage
        });
      });
    };

    const error = response => {
      this.setState({
        hasFailed: true,
        hasSucceeded: false,
        errorMessage: (response.booking && response.booking.message) || defaultMessage
      });
    };

    const complete = () => this.setState({
      isBookingInProgress: false
    }, this._togglePageLoading);

    this.setState({ isBookingInProgress: true });

    $.ajax({
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content
      },
      type: "POST",
      dataType: "json",
      url,
      data,
      success,
      error,
      complete
    });
  };

  prebookOffer = (pax, teeTimeIds, customerParams) => {
    this._makePrebooking(pax, teeTimeIds, customerParams);
  };

  _updateSelectedTimesAndPax = (pax, teeTimes) => {
    this.setState({
      selectedPax: pax,
      selectedTeeTimes: teeTimes
    });
  };

  _incrementPanelNumber = () => {
    this.setState(prevState => {
      const panelNumber = prevState.panelNumber
      const newPanelNumber = panelNumber + 1

      return {
        panelNumber: newPanelNumber,
        offerSelected: newPanelNumber > 0
      };
    });
  };

  _decrementPanelNumber = () => {
    this.setState(prevState => {
      const panelNumber = prevState.panelNumber;
      const newPanelNumber = panelNumber - 1;

      return {
        panelNumber: newPanelNumber,
        offerSelected: newPanelNumber > 0
      };
    });
  };

  _formatPax = pax => pluralize("golfer", pax, true);

  proceedToCheckout = (pax, teeTimes) => {
    this._updateSelectedTimesAndPax(pax, teeTimes);
    this._incrementPanelNumber();
  };

  deselectOffer = () => this._decrementPanelNumber();

  selectOffer = () => this._incrementPanelNumber();

  isActivePanel = panelNumber => this.state.panelNumber === panelNumber;

  render() {
    const self = this;
    const { props, state } = this;

    const {
      date,
      paxOptions,
      pricePerPerson,
      nights,
      rounds,
      roundsByCourse,
      teeTimes,
      boardBasis,
      addedValueOffers
    } = props.offer;

    const formattedPrice = pricePerPerson.toFixed(pricePerPerson % 1 === 0 ? 0 : 2);
    const formattedDate = dayjs(date).format(OFFER_DATE_FORMAT);
    const selectedPax = state.selectedPax;
    const bookButtonSubText = `£${formattedPrice * selectedPax} for ${self._formatPax(selectedPax)}`;

    const headerProps = {
      nights,
      rounds,
      formattedPrice,
      deselectOffer: self.deselectOffer
    };

    const summaryProps = {
      date,
      formattedDate,
      boardBasis,
      paxOptions,
      roundsByCourse,
      addedValueOffers
    };

    const teeTimesFormProps = {
      formattedDate,
      boardBasis,
      paxOptions,
      formattedPrice,
      roundsByCourse,
      teeTimes,
      proceedToCheckout: self.proceedToCheckout
    };

    const customerDetailsFormProps = {
      bookOffer: self.prebookOffer,
      selectedTeeTimes: state.selectedTeeTimes,
      consentStatement: props.consentStatement,
      selectedPax,
      bookButtonSubText
    };

    return (
      <div
        className={classnames(
          "venue__offer venue__offer--last-minute",
          state.offerSelected && "is-selected",
          state.hasSucceeded && "has-succeeded",
          state.hasFailed && "has-failed"
        )}
        id={`offer-${props.offer.id}`}
      >
        <Loading isLocal isLoading={state.isStripeLoading} />

        <OfferHeader {...headerProps} />

        <div className="panels">
          <div className={classnames("panel", self.isActivePanel(0) && "panel__active")}>
            <OfferSummary {...summaryProps} />

            <SelectOffer
              isVenuePage={props.isVenuePage}
              label={props.selectLabel}
              selectOffer={self.selectOffer}
            />
          </div>

          <div className={classnames("panel", self.isActivePanel(1) && "panel__active")}>
            <TeeTimesForm {...teeTimesFormProps} />
          </div>

          <div className={classnames("panel", self.isActivePanel(2) && "panel__active")}>
            <CustomerDetailsForm {...customerDetailsFormProps} />
          </div>

          {state.hasSucceeded &&
            <OfferConfirmation reference={state.reference} />
          }

          {state.hasFailed &&
            <OfferError message={state.errorMessage} />
          }
        </div>
      </div>
    );
  }
}

export default Offer;



// WEBPACK FOOTER //
// ./components/last_minute_deals/Offer.jsx